/*document.addEventListener("DOMContentLoaded", () => {
  const gallery = document.getElementById("qsGallery");
  if (!gallery) return;

  const variantInput = document.querySelector('form[action="/cart/add"] [name="id"]');
  if (!variantInput) return;

  const mediaItems = gallery.querySelectorAll(".qs-item img");

  const observer = new MutationObserver(() => {
    const newVariant = variantInput.value;

    const found = Shopify.productJSON.media.find(
      m => m.variant_ids && m.variant_ids.includes(Number(newVariant))
    );

    if (found) {
      const img = gallery.querySelector(`img[src*="${found.src}"]`);
      if (img) {
        img.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }
  });

  observer.observe(variantInput, { attributes: true, attributeFilter: ["value"] });
});*/
document.addEventListener("variant:change", (event) => {
  const variant = event.detail.variant;
  if (!variant || !variant.featured_media) return;

  const newMediaId = variant.featured_media.id;

  const firstItem = document.querySelector(".qs-item.item-1");
  const newItem = document.querySelector(`[data-media-id="${newMediaId}"]`);

  if (newItem && firstItem) {
    // Move clicked variant image into grid position A
    firstItem.classList.remove("item-1");
    newItem.classList.add("item-1");
    
    // Also reorder DOM so it appears first
    const grid = document.getElementById("qs-gallery");
    grid.prepend(newItem);
  }
});

